import React from 'react';
import blogCover from '../images/blog10.png';
import blogCover2 from '../images/blog16.png';
import OurPartner from '../pages/components/OurPartner';
import SuggestedBlogs from './components/SuggestedBlogs';

import { FaUser, FaCalendarAlt, FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { features } from "./components/BlogSection";
import { Link } from "react-router-dom";

const currentIndex = features.findIndex(
    (blog) => blog.link === "/high-performance-web-applications"
);

const prevBlog = features[currentIndex - 1];
const nextBlog = features[currentIndex + 1];

function HighPerformanceWebApplications() {

    const postDate = "March 6, 2026";

    return (
        <>
            {/* BLOG HEADER */}
            <section className="container my-5">

                <div className="text-center mb-4">

                    <h1 className="fw-bold responsive-heading mb-3">
                        <span className="highlight-orange">
                            How Peregrinee Delivers High-Performance Web Applications
                        </span>
                    </h1>

                    <p className="mt-3 text-muted fs-5">
                        Discover how Peregrinee builds fast, scalable, secure, and
                        future-ready web applications engineered for performance
                        and growth.
                    </p>

                    {/* AUTHOR + DATE */}
                    <div className="d-flex justify-content-center align-items-center gap-4 mt-3 text-muted">

                        <span className="d-flex align-items-center gap-2">
                            <FaUser />
                            Posted by <strong>Peregrinee</strong>
                        </span>

                        <span className="d-flex align-items-center gap-2">
                            <FaCalendarAlt />
                            {postDate}
                        </span>

                    </div>

                </div>

            </section>


            {/* HERO IMAGE */}
            <section className="container mb-5">

                <img
                    src={blogCover}
                    alt="High Performance Web Applications"
                    className="img-fluid rounded-4 shadow w-100"
                    style={{ maxHeight: "500px", objectFit: "cover" }}
                />

            </section>


            {/* SECTION 1 */}
            <section className="container my-5 shadow-sm p-4 p-lg-5 rounded-4 bg-white">

                <div className="row align-items-center gy-4">

                    <div className="col-lg-6">

                        <img
                            src={blogCover}
                            alt="High Performance Web Applications"
                            className="img-fluid rounded-4 shadow-sm w-100"
                            style={{ objectFit: "cover", maxHeight: "420px" }}
                        />

                    </div>

                    <div className="col-lg-6">

                        <h3 className="fw-bold highlight-orange">
                            What Defines a High-Performance Web Application?
                        </h3>

                        <p>
                            A high-performance web application is optimized
                            for speed, scalability, reliability, and security.
                            It loads quickly, handles heavy traffic efficiently,
                            and maintains stability even under peak demand.
                        </p>

                        <h3 className="fw-bold highlight-orange mt-4">
                            Why Performance Matters
                        </h3>

                        <p>
                            Slow-loading applications cause user drop-offs,
                            revenue loss, and poor search rankings. Businesses
                            today require platforms that deliver seamless
                            experiences across all devices and network conditions.
                        </p>

                        <ul className="ps-3">
                            <li>Faster load times improve user retention</li>
                            <li>Optimized systems reduce operational costs</li>
                            <li>Scalable infrastructure supports business growth</li>
                            <li>Stable performance strengthens brand credibility</li>
                        </ul>

                    </div>

                </div>

            </section>


            {/* SECTION 2 */}
            <section className="container my-5 shadow-sm p-4 p-lg-5 rounded-4 bg-white">

                <div className="row align-items-center gy-4">

                    <div className="col-lg-6 order-lg-1 order-2">

                        <h3 className="fw-bold highlight-orange">
                            Peregrinee’s Performance-First Approach
                        </h3>

                        <p>
                            At Peregrinee, performance is built into the
                            architecture from day one. Our team focuses on
                            clean code, modular systems, optimized databases,
                            and efficient API communication.
                        </p>

                        <p>
                            From frontend responsiveness to backend scalability,
                            every layer is engineered to reduce latency and
                            maximize reliability.
                        </p>

                        <h3 className="fw-bold highlight-orange mt-4">
                            Continuous Optimization
                        </h3>

                        <p>
                            Our team continuously monitors system performance,
                            improves caching strategies, optimizes queries,
                            and scales infrastructure according to usage
                            patterns.
                        </p>

                        <a
                            href="/contact-us"
                            className="btn btn-orange rounded-pill px-4 py-2 fw-bold mt-3"
                            style={{ width: "fit-content" }}
                        >
                            Build a High-Performance Web App
                        </a>

                    </div>

                    <div className="col-lg-6 order-lg-2 order-1">

                        <img
                            src={blogCover2}
                            alt="Performance Driven Development"
                            className="img-fluid rounded-4 shadow-sm w-100"
                            style={{ objectFit: "cover", maxHeight: "420px" }}
                        />

                    </div>

                </div>

            </section>


            {/* SECTION 3 */}
            <section className="container my-5 shadow-sm p-5 rounded-4 bg-white">

                <h2 className="fw-bold highlight-orange mb-4 text-center">
                    Scalable Architecture & Infrastructure Design
                </h2>

                <p>
                    Peregrinee designs scalable architectures that grow with
                    your business. Whether your application serves hundreds
                    or millions of users, our infrastructure ensures stability
                    under increasing traffic.
                </p>

                <ul className="ps-3">
                    <li>Microservices & modular architecture</li>
                    <li>Cloud-native deployment</li>
                    <li>Load balancing & horizontal scaling</li>
                    <li>Efficient caching mechanisms</li>
                    <li>Optimized database indexing</li>
                </ul>

            </section>


            {/* SECTION 4 */}
            <section className="container my-5 shadow-sm p-5 rounded-4 bg-white">

                <h2 className="fw-bold highlight-orange mb-4 text-center">
                    Frontend & Backend Performance Optimization
                </h2>

                <p>
                    Peregrinee reduces bundle sizes, implements lazy loading,
                    and optimizes asset delivery for faster rendering.
                </p>

                <p>
                    On the backend, we minimize response time through optimized
                    database queries, caching strategies, and efficient
                    server-side processing.
                </p>

            </section>


            {/* SECTION 5 */}
            <section className="container my-5 shadow-sm p-5 rounded-4 bg-white">

                <h2 className="fw-bold highlight-orange mb-4 text-center">
                    Security, Stability & Reliability
                </h2>

                <p>
                    Security is integrated with performance. Peregrinee
                    implements encrypted communication, secure authentication,
                    and role-based access systems to protect business data.
                </p>

                <p>
                    Regular monitoring and proactive maintenance ensure
                    long-term system stability and minimal downtime.
                </p>

            </section>


            {/* SECTION 6 */}
            <section className="container my-5 shadow-sm p-5 rounded-4 bg-white">

                <h2 className="fw-bold highlight-orange mb-4 text-center">
                    Long-Term Performance Monitoring & Scaling
                </h2>

                <p>
                    Performance requires continuous monitoring. Peregrinee
                    provides analytics review, system upgrades, and scaling
                    strategies as your user base grows.
                </p>

                <p>
                    This ensures your application remains fast, stable,
                    and capable of handling increasing traffic.
                </p>

                <div className="text-center mt-4">

                    <a
                        href="/contact-us"
                        className="btn btn-orange rounded-pill px-5 py-3 fw-bold"
                        style={{ width: "fit-content" }}
                    >
                        Partner with Peregrinee for Performance Excellence
                    </a>

                </div>

            </section>


            {/* BLOG NAVIGATION */}
            <section className="container my-5">

                <div className="row">

                    {prevBlog && (
                        <div className="col-md-6 mb-3">

                            <Link
                                to={prevBlog.link}
                                className="d-flex align-items-center gap-3 p-3 border rounded-4 text-decoration-none blog-nav"
                            >

                                <FaArrowLeft />

                                <div>
                                    <small className="text-muted">Previous Blog</small>
                                    <h6 className="mb-0 fw-bold">{prevBlog.title}</h6>
                                </div>

                            </Link>

                        </div>
                    )}

                    {nextBlog && (
                        <div className="col-md-6 mb-3 text-md-end">

                            <Link
                                to={nextBlog.link}
                                className="d-flex align-items-center justify-content-md-end gap-3 p-3 border rounded-4 text-decoration-none blog-nav"
                            >

                                <div>
                                    <small className="text-muted">Next Blog</small>
                                    <h6 className="mb-0 fw-bold">{nextBlog.title}</h6>
                                </div>

                                <FaArrowRight />

                            </Link>

                        </div>
                    )}

                </div>

            </section>


            <SuggestedBlogs />

            <OurPartner />

        </>
    );
}

export default HighPerformanceWebApplications;